import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaShoppingCart, FaBoxOpen, FaStar } from "react-icons/fa";
import { resolveAssetUrl } from "../utils/assets";
import { getProductCategory } from "../utils/categories";
import { useCart } from "../context/CartContext";
import { getDefaultCartExtras } from "../utils/variants";
import "./ProductCard.css";

function StarRating({ rating = 0 }) {
  const value = Number(rating) || 0;
  if (value <= 0) return null;
  return (
    <div className="product-rating" aria-label={`${value} out of 5`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <FaStar key={n} className={n <= Math.round(value) ? "filled" : ""} />
      ))}
      <span>{value.toFixed(1)} out of 5</span>
    </div>
  );
}

const ProductCard = ({ product, onAddToCart, layout = "grid" }) => {
  const { isInCart } = useCart();
  const [busy, setBusy] = useState(false);
  const [imgFailed, setImgFailed] = useState(false);
  const category = getProductCategory(product);
  const categoryName = category?.name || "General";
  const categoryHref = category?.slug
    ? `/products?category=${encodeURIComponent(category.slug)}`
    : null;  const cover = product.images?.[0] || product.image || "";
  const image = resolveAssetUrl(cover);
  const price =
    typeof product.price === "number"
      ? product.price.toFixed(2)
      : product.price;
  const to = `/product/${product.slug || product.id}`;
  const defaultExtras = getDefaultCartExtras(product);
  const alreadyInCart = isInCart(product.id, defaultExtras.variantId);

  useEffect(() => {
    setImgFailed(false);
  }, [image]);

  const run = async (fn) => {
    if (!fn || busy) return;
    setBusy(true);
    try {
      await fn(product);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`product-card ${layout === "list" ? "list-layout" : ""}`}>
      <Link to={to} className="product-image-placeholder">
        {image && !imgFailed ? (
          <img
            src={image}
            alt={product.name}
            loading="lazy"
            decoding="async"
            onError={() => setImgFailed(true)}
          />
        ) : (
          <>
            <FaBoxOpen />
            <span>Product Image</span>
          </>
        )}
      </Link>

      <div className="product-content">
        {categoryHref ? (
          <Link to={categoryHref} className="product-category">
            {categoryName}
          </Link>
        ) : (
          <span className="product-category">{categoryName}</span>
        )}
        <h3>
          <Link to={to}>{product.name}</Link>
        </h3>
        {(product.reviewCount || 0) > 0 && (
          <StarRating rating={product.averageRating} />
        )}
        <p className="product-price">
          {Number(price).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          AED
        </p>

        {alreadyInCart ? (
          <Link to="/cart" className="add-cart-btn go-cart-btn">
            <FaShoppingCart />
            Go to Cart
          </Link>
        ) : (
          <button
            type="button"
            className="add-cart-btn"
            disabled={busy}
            onClick={() => run(onAddToCart)}
          >
            <FaShoppingCart />
            {busy ? "Please wait..." : "Add to Cart"}
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
